import { categorySlice } from "./store/category.slice";
import {
  certificateCategoryApi,
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useLazyGetCategoryByIdQuery,
  useLazyGetCategoriesQuery,
  useDeleteCategoryMutation,
  useReorderCategoriesMutation,
} from "./api/category.api";

export const { setCategories } = categorySlice.actions;

export {
  certificateCategoryApi,
  categorySlice,
  useReorderCategoriesMutation,
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useLazyGetCategoryByIdQuery,
  useLazyGetCategoriesQuery,
  useDeleteCategoryMutation
};
